
"use strict";

!function () {
  var t = window.driftt = window.drift = window.driftt || [];
  if (!t.init) {
    if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
    t.invoked = !0, t.methods = ["identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on"],
      t.factory = function (e) {
        return function () {
          var n = Array.prototype.slice.call(arguments);
          return n.unshift(e), t.push(n), t;
        };
      }, t.methods.forEach(function (e) {
        t[e] = t.factory(e);
      }), t.load = function (t) {
        var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
        o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
        var i = document.getElementsByTagName("script")[0];
        i.parentNode.insertBefore(o, i);
      };
  }
}();
function callback(mutationList, driftContainerObserver) {
  const driftContainer = document.querySelector('#drift-frame-chat')
  mutationList.forEach(function(mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class' && mutation.target.classList.contains('drift-chat-open')) {
      driftContainer.style.maxHeight= '90%';
    }
  })
}

const driftContainerObserver = new MutationObserver(callback)

const isDriftReady = ()=>window.drift.chatReady;
const initDrift = () =>  {
  return new Promise((resolve, reject) => {
    drift.SNIPPET_VERSION = '0.3.1';
    drift.load('6eyim69wu4kg');
    drift.on('ready', function (api, payload) {
      drift.api.widget.hide();
      resolve(true)
    })
  });
}

drift.on('chatClose',function(e){
  driftContainerObserver.disconnect();
  drift.api.widget.hide()
})

function openDrift(){
  drift.api.openChat();
  const driftContainer = document.querySelector('#drift-frame-chat')
  const options = {
    attributes: true
  }
  driftContainerObserver.observe(driftContainer, options)
}